<template>
  <a
    href="javascript:void(0)"
    class="btn btn-icon btn-light btn-hover-danger btn-sm mx-1"
    v-b-tooltip.hover.top
    :title="$t('TABLES.USER_TOOLTIPS.BLOCK')"
    @click="suspendUserAlert(user, arrayPos)"
  >
    <span class="svg-icon svg-icon-md svg-icon-danger">
      <inline-svg src="media/svg/icons/General/Lock.svg" />
    </span>
  </a>
</template>

<script>
import { SUSPEND_USER } from "@/core/services/store/core/user.module";

export default {
  name: "SuspendUser",

  props: ['user', 'arrayPos'],

  methods: {
    suspendUserAlert(user, arrayPos) {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.BLOCK_CHALLENGE.TITLE")}`,
        text: user.display_name + " " + `${this.$t("SWEETALERTS.BLOCK_CHALLENGE.MESSAGE")}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${this.$t("SWEETALERTS.BLOCK_CHALLENGE.CONFIRM")}`,
        cancelButtonText: `${this.$t("GENERAL.TEXT.CANCEL")}`,
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = { userId: user.id, arrayPos: arrayPos };
          this.$store.dispatch(SUSPEND_USER, payload).then(() => {
            this.$swal.fire({
              title: `${this.$t("SWEETALERTS.BLOCK_SUCCESS.TITLE")}`,
              text: user.display_name + ' ' + `${this.$t("SWEETALERTS.BLOCK_SUCCESS.MESSAGE")}`,
              icon: 'success',
              confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
            })          
          })
          .catch(() => {
            this.$swal.fire({
              title: `${this.$t("GENERAL.TEXT.VAGUE_ERROR_TITLE")}`,
              text: `${this.$t("SWEETALERTS.BLOCK_FAIL.MESSAGE")}`,
              icon: 'error',
              confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
            })  
          })
        }
      })
    },
  }
};
</script>
